// drizzle/v2Schema.ts
import { user } from './authSchema';
import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { ulid } from 'ulid';

export * from './authSchema';

export const workspaces = sqliteTable('workspace', {
  createdAt: integer({ mode: 'timestamp' })
    .notNull()
    .$defaultFn(() => new Date()),
  deletedAt: integer({ mode: 'timestamp_ms' }),
  id: text('id')
    .primaryKey()
    .$defaultFn(() => ulid()),
  position: integer().notNull().default(0),
  title: text().notNull().default(''),
  updatedAt: integer({ mode: 'timestamp_ms' })
    .notNull()
    .$defaultFn(() => new Date())
    .$onUpdateFn(() => new Date()),
  userId: text()
    .notNull()
    .references(() => user.id),
});

export const processes = sqliteTable('process_v2', {
  archivedAt: integer({ mode: 'timestamp' }),
  createdAt: integer({ mode: 'timestamp' })
    .notNull()
    .$defaultFn(() => new Date()),
  deletedAt: integer({ mode: 'timestamp_ms' }),
  id: text('id')
    .primaryKey()
    .$defaultFn(() => ulid()),
  isPinned: integer({ mode: 'boolean' }).notNull().default(false),
  snoozedUntil: integer({ mode: 'timestamp' }),
  title: text().notNull().default(''),
  updatedAt: integer({ mode: 'timestamp_ms' })
    .notNull()
    .$defaultFn(() => new Date())
    .$onUpdateFn(() => new Date()),
  userId: text()
    .notNull()
    .references(() => user.id),
  workspaceId: text()
    .notNull()
    .references(() => workspaces.id),
});

export const items = sqliteTable('item', {
  completedAt: integer({ mode: 'timestamp' }),
  content: text().notNull().default(''),
  createdAt: integer({ mode: 'timestamp' })
    .notNull()
    .$defaultFn(() => new Date()),
  deletedAt: integer({ mode: 'timestamp_ms' }),
  id: text('id')
    .primaryKey()
    .$defaultFn(() => ulid()),
  metadata: text({ mode: 'json' }),
  processId: text()
    .notNull()
    .references(() => processes.id, { onDelete: 'cascade' }),
  type: text().notNull(),
  updatedAt: integer({ mode: 'timestamp_ms' })
    .notNull()
    .$defaultFn(() => new Date())
    .$onUpdateFn(() => new Date()),
  userId: text()
    .notNull()
    .references(() => user.id),
});

export const activity = sqliteTable('activity', {
  createdAt: integer({ mode: 'timestamp' })
    .notNull()
    .$defaultFn(() => new Date()),
  id: text('id')
    .primaryKey()
    .$defaultFn(() => ulid()),
  itemId: text().references(() => items.id, { onDelete: 'set null' }),
  metadata: text({ mode: 'json' }),
  processId: text()
    .notNull()
    .references(() => processes.id, { onDelete: 'cascade' }),
  type: text().notNull(),
  userId: text()
    .notNull()
    .references(() => user.id),
});
